const DRM_ADDER = "+((x=t>>(y=2+1*'99999999999999889999999967886855999999997788886799999999678568459199297788999756956999946788685347999999778888649391990664075405'[t>>10&127])&2)-1)*(6E3*(x+1)/(t&(2**(y+1)-1))&1)*64";
const HEAVY_AF_PREFIX = `(s=sin(t>>5),h=1&t,t*=.18,b=2E5/(t&2**10/[1,,h,,s,,h,1,1,,s,,1,1,1,h,1,,h,,s,,h,,1,2,s,1,s,1,t&42,1.06*t&55][(t>>10)%32]-1),n=(`;
const HEAVY_AF_SUFFIX = `),[b%149^n,b%150^n])`;
const SWANGER_PREFIX = 't-=t/4&256,';
const DRUMS_PREFIX = '(t>>9&1+t>>12&7?0:9001/(t%4096)-t/9&8?-1:0)^t>>4&';
const CA_PREFIX = 't+=sin(t/100)*t/8000,';
const SHUFFLER_PREFIX = 't+=(t>>14^t>>11|t>>9&7&t>>10)*2**12,';
const ADDER_HC_SUFFIX = '+((sqrt(4E3*(t&16383))&128|t>>5&128)/1.5+random()*((-t>>6)%64+64)+(4E6/(16383+t&32767)&192)/1.5)/1.8';
const ADDER_HC2_SUFFIX = '+(sqrt(5E3*(t%65536&(2**[9,12,12,14,,,,,13,12,11,14][(t>>11&15|t^t/32%8*t)&11])-1))&128)';
const expressionCode = code => code.replace(/;\s*$/, '');

const echoWithoutFill = code =>
	`(globalThis._bytebeatEcho||(globalThis._bytebeatEcho=[]),globalThis._bytebeatEcho[t&8191]=(${ expressionCode(code) })+(globalThis._bytebeatEcho[(t-4096)&8191]||0)*.5)`;
const echoWithFill = code =>
	`(globalThis._bytebeatEchoAF||(globalThis._bytebeatEchoAF=Array(8192).fill(0)),globalThis._bytebeatEchoAF[t&8191]=(${ expressionCode(code) })+globalThis._bytebeatEchoAF[(t-4096)&8191]*.5)`;

const isWordCharacter = char => char && /[\w$]/.test(char);

const minify = code => {
	let output = '';
	let quote = null;
	for(let i = 0; i < code.length; ++i) {
		const char = code[i];
		if(quote) {
			output += char;
			if(char === '\\' && i + 1 < code.length) {
				output += code[++i];
			} else if(char === quote) {
				quote = null;
			}
			continue;
		}
		if(char === '"' || char === '\'' || char === '`') {
			quote = char;
			output += char;
			continue;
		}
		if(char === '/' && code[i + 1] === '/') {
			while(i < code.length && code[i] !== '\n') {
				++i;
			}
			continue;
		}
		if(char === '/' && code[i + 1] === '*') {
			i += 2;
			while(i < code.length - 1 && !(code[i] === '*' && code[i + 1] === '/')) {
				++i;
			}
			++i;
			continue;
		}
		if(/\s/.test(char)) {
			let next = i + 1;
			while(next < code.length && /\s/.test(code[next])) {
				++next;
			}
			if(isWordCharacter(output.at(-1)) && isWordCharacter(code[next])) {
				output += ' ';
			}
			i = next - 1;
			continue;
		}
		output += char;
	}
	return output;
};

const minibake = code => {
	if(code.length & 1) {
		code += ' ';
	}
	code = code.replace(/, /g, ',');
	let output = '';
	for(let i = 0; i < code.length; i += 2) {
		output += String.fromCharCode((code.charCodeAt(i) << 8) | code.charCodeAt(i + 1));
	}
	return `eval(unescape(escape\`${ output }\`.replace(/u(..)/g,"$1%")))`;
};

const deminibake = code => code.trim().replace(
	/^eval\(unescape\(escape(?:`|\('|\("|\(`)(.*?)(?:`|'\)|"\)|`\)).replace\(\/u\(\.\.\)\/g,["'`]\$1%["'`]\)\)\)$/,
	(match, baked) => unescape(escape(baked).replace(/u(..)/g, '$1%'))
);

const encodeInteger = number => {
	number = Math.abs(number);
	if(number === 0) {
		return '+[]';
	}
	const bits = number.toString(2);
	let output = '+!![]';
	for(const bit of bits.slice(1)) {
		output = `(${ output }<<!![])${ bit === '1' ? '+!![]' : '' }`;
	}
	return output;
};

const encodeNumber = token => {
	const number = Number(token);
	if(!Number.isFinite(number) || Number.isInteger(number)) {
		const value = encodeInteger(number);
		return number < 0 ? `-(${ value })` : value;
	}
	const sign = number < 0 ? '-' : '';
	const digits = Math.abs(number).toString().split('.');
	const numerator = encodeInteger(Number(digits.join('')));
	const denominator = encodeInteger(10 ** digits[1].length);
	return `${ sign }(${ numerator }/${ denominator })`;
};

const noNumbers = code => {
	let output = '';
	let quote = null;
	for(let i = 0; i < code.length;) {
		const char = code[i];
		if(quote) {
			output += char;
			++i;
			if(char === '\\' && i < code.length) {
				output += code[i++];
			} else if(char === quote) {
				quote = null;
			}
			continue;
		}
		if(char === '"' || char === '\'' || char === '`') {
			quote = char;
			output += char;
			++i;
			continue;
		}
		if(char === '/' && code[i + 1] === '/') {
			const end = code.indexOf('\n', i);
			output += code.slice(i, end < 0 ? code.length : end);
			i = end < 0 ? code.length : end;
			continue;
		}
		if(char === '/' && code[i + 1] === '*') {
			const end = code.indexOf('*/', i + 2);
			output += code.slice(i, end < 0 ? code.length : end + 2);
			i = end < 0 ? code.length : end + 2;
			continue;
		}
		const match = code.slice(i).match(/(?:\d+(?:\.\d*)?|\.\d+)(?:e[+-]?\d+)?/i);
		if(match && !isWordCharacter(code[i - 1]) && !isWordCharacter(code[i + match[0].length])) {
			output += encodeNumber(match[0]);
			i += match[0].length;
		} else {
			output += char;
			++i;
		}
	}
	return output;
};

const addSwing = code => {
	if(/^\s*t\s*\*=/.test(code)) {
		let quote = null;
		let depth = 0;
		for(let i = 0; i < code.length; ++i) {
			const char = code[i];
			if(quote) {
				if(char === '\\') {
					++i;
				} else if(char === quote) {
					quote = null;
				}
				continue;
			}
			if(char === '"' || char === '\'' || char === '`') {
				quote = char;
			} else if(char === '(' || char === '[' || char === '{') {
				++depth;
			} else if(char === ')' || char === ']' || char === '}') {
				--depth;
			} else if(depth === 0 && (char === ',' || char === ';')) {
				return code.slice(0, i + 1) + SWANGER_PREFIX + code.slice(i + 1);
			}
		}
	}
	return SWANGER_PREFIX + `(${ code })`;
};

export class Tools {
	constructor(getCode, setCode) {
		this.getCode = getCode;
		this.setCode = setCode;
	}
	initElements() {}
	run(name) {
		const code = this.getCode().trim();
		let result = code;
		switch(name) {
		case 'minibaker':
			if(deminibake(code) !== code) {
				window.alert('This formula is already minibaked.');
				return;
			}
			result = minibake(code);
			break;
		case 'deminibaker': result = deminibake(code); break;
		case 'minifier': result = minify(code); break;
		case 'no-numbers': result = noNumbers(code); break;
		case 'adder-drm': result = code + DRM_ADDER; break;
		case 'combiner': {
			const additional = window.prompt('Enter one or more formulas, one per line:');
			if(additional === null) {
				return;
			}
			const formulas = [code, ...additional.split(/\r?\n/).map(item => item.trim()).filter(Boolean)];
			result = formulas.map(item => `(${ item })`).join('+');
			break;
		}
		case 'heavy-af': result = HEAVY_AF_PREFIX + code + HEAVY_AF_SUFFIX; break;
		case 'swanger': result = addSwing(code); break;
		case 'drums-c': result = DRUMS_PREFIX + `(${ code })`; break;
		case 'ca-ifier': result = CA_PREFIX + code; break;
		case 'echo-doer': result = echoWithoutFill(code); break;
		case 'echo-doer-af': result = echoWithFill(code); break;
		case 'adder-hc': result = code + ADDER_HC_SUFFIX; break;
		case 'shuffler': result = SHUFFLER_PREFIX + code; break;
		case 'adder-hc2': result = code + ADDER_HC2_SUFFIX; break;
		default: return;
		}
		if(result !== code) {
			this.setCode(result);
		}
	}
}
